import React from "react";

function WithOutTaxBillingSetupComponent(){
    return (
        <h1> WithOut billing Setup</h1>
    )
}

export default WithOutTaxBillingSetupComponent